<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Dengan Nama Pembagian"
        />
        <span class="text-danger text-sm">{{ errors.first("name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Persentase (%)</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          icon-after="true"
          icon="percent"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="percentage"
          class="w-full sidebar-input"
          v-model="formData.persentase"
          placeholder="Isi Dengan Persentase (%)"
        />
        <span class="text-danger text-sm">{{ errors.first("percentage") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nominal Maksimal (Rp)</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="max price"
          class="w-full sidebar-input"
          v-model="nominal"
          placeholder="Isi Dengan Nominal Maksimal"
        />
        <span class="text-danger text-sm">{{ errors.first("max price") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      formData: {
        name: "",
        persentase: null,
        max_rupiah: null,
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Pembagian" : "Tambah Pembagian";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    nominal: {
      get() {
        return this.formatRupiah(this.formData.max_rupiah);
      },
      set(val) {
        // Do something with the val here...
        this.formData.max_rupiah = val;
      },
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.persentase !== null &&
        this.formData.max_rupiah !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.name = this.passData.name;
        this.formData.persentase = this.passData.persentase;
        this.nominal = this.passData.max_rupiah.toString();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.name = "";
      this.formData.persentase = null;
      this.formData.max_rupiah = null;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      this.formData.max_rupiah = this.formData.max_rupiah.replaceAll(".", "");
      this.$store
        .dispatch("journal/cudPembagian", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Pembagian Sukses!"
                : "Tambah Pembagian Sukses!",
            text:
              this.passData !== null
                ? `Pembagian ${v.name} Berhasil diedit`
                : `Pembagian ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>
